import type { WatchHotspotId, WatchInspectionMode, WatchVariant } from "@/demos/types";

/** Wireframe 6's "materials" swatch row. */
export const watchVariants: ReadonlyArray<{ id: WatchVariant; label: string; color: string }> = [
  { id: "surgical-white", label: "Surgical White", color: "#e7e7e4" },
  { id: "midnight-gold", label: "Midnight Gold", color: "#d8a44f" },
  { id: "commerce-green", label: "Commerce Green", color: "#2d6b42" },
  { id: "khronos-red", label: "Khronos Red", color: "#bd2727" },
];

/** Wireframe 6's numbered hotspots and the panel each one opens. */
export const watchHotspots: Readonly<Record<Exclude<WatchHotspotId, "none">, { label: string; description: string }>> = {
  band: {
    label: "Carbon-fibre band",
    description: "A lightweight band combining carbon-fibre detail with configurable polymer sections.",
  },
  bezel: {
    label: "Protective bezel",
    description: "The raised bezel protects the glass while carrying the selected material finish.",
  },
  buttons: {
    label: "Chronograph controls",
    description: "Dedicated metal and polymer controls demonstrate multi-material variant mapping.",
  },
  glass: {
    label: "Transmissive glass",
    description: "A physically based transparent surface protects the dial and can be removed in technical view.",
  },
  dial: {
    label: "Animated dial",
    description: "Separate hour, minute and second hands preserve product detail and authored animation.",
  },
};

export const inspectionModes: ReadonlyArray<{ id: WatchInspectionMode; label: string }> = [
  { id: "assembled", label: "Assembled" },
  { id: "technical", label: "Technical" },
];
